document.addEventListener('DOMContentLoaded', function () {
  const tabHeadings = Array.from(document.querySelectorAll('.tab-heading')),
    tabContents = Array.from(document.querySelectorAll('.tab-content')),
    dimensionContents = Array.from(document.querySelectorAll('.dimensions__container')),
    sectionalButtons = document.querySelectorAll('.sectionals__button');
  if (tabHeadings.length && tabContents.length) {
    let addTabListeners2 = function (heading) {
        (heading.addEventListener('click', () => setActiveTab2(heading)),
          heading.addEventListener('keydown', (evt) => {
            let currentTab = evt.currentTarget;
            switch (evt.key) {
              case 'ArrowLeft':
                selectTabByIndex2(tabHeadings.indexOf(currentTab) - 1);
                break;
              case 'ArrowRight':
                selectTabByIndex2(tabHeadings.indexOf(currentTab) + 1);
                break;
              case 'Home':
                setActiveTab2(firstTab);
                break;
              case 'End':
                setActiveTab2(lastTab);
                break;
              default:
                break;
            }
            (evt.stopPropagation(), evt.preventDefault());
          }));
      },
      setActiveTab2 = function (trigger) {
        const triggerIndex = tabHeadings.indexOf(trigger);
        if (trigger.classList.contains('active')) return;
        (tabContents.forEach((content, contentIndex) => {
          content.classList.toggle('active', triggerIndex === contentIndex);
        }),
          dimensionContents.forEach((dimension, dimensionIndex) => {
            dimension.classList.toggle('active', triggerIndex === dimensionIndex);
          }),
          tabHeadings.forEach((item) => {
            const isActive = item === trigger;
            (item.classList.toggle('active', isActive),
              item.setAttribute('aria-selected', isActive),
              item.removeAttribute('tabindex'));
          }));
        const activeButton = document.querySelector('.tab-content.active .sectionals__button.active');
        if (activeButton) {
          const newUrl = activeButton.getAttribute('data-url'),
            shopNowButton = document.getElementById('sectionals__shop_now_button');
          shopNowButton && shopNowButton.setAttribute('href', newUrl);
        }
      },
      selectTabByIndex2 = function (index) {
        index < 0
          ? setActiveTab2(lastTab)
          : index >= tabHeadings.length
            ? setActiveTab2(firstTab)
            : setActiveTab2(tabHeadings[index]);
      };
    var addTabListeners = addTabListeners2,
      setActiveTab = setActiveTab2,
      selectTabByIndex = selectTabByIndex2;
    const firstTab = tabHeadings[0],
      lastTab = tabHeadings[tabHeadings.length - 1];
    tabHeadings.forEach((heading) => {
      addTabListeners2(heading);
    });
  }
  sectionalButtons.forEach((button) => {
    button.addEventListener('click', () => toggleSection(button));
  });
  function toggleSection(button) {
    const contentWrapper = button.closest('.sectionals__content'),
      buttonsWrapper = contentWrapper.querySelector('.sectionals__buttons-wrapper'),
      imagesWrapper = contentWrapper.querySelector('.sectionals__images-wrapper'),
      dimensionsWrapper = document.querySelector('.dimensions__container.active'),
      dimensions = dimensionsWrapper.querySelectorAll('.dimensions__content .dimensions'),
      dimensionsImages = dimensionsWrapper.querySelectorAll('.dimensions__images .dimension__image'),
      sectionButton = document.getElementById('sectionals__shop_now_button');
    (removeActive(buttonsWrapper.querySelectorAll('.sectionals__button')),
      removeActive(imagesWrapper.querySelectorAll('.sectionals__image')),
      removeActive(dimensions),
      removeActive(dimensionsImages),
      button.classList.add('active'),
      dimensionsWrapper.querySelector(`.dimensions[data-trigger="${button.dataset.trigger}"]`).classList.add('active'),
      dimensionsWrapper.querySelector(`.dimension__image[data-id="${button.dataset.trigger}"]`).classList.add('active'),
      imagesWrapper.querySelector(`.sectionals__image[data-id="${button.dataset.trigger}"]`).classList.add('active'));
    const itemUrl = button.getAttribute('data-url');
    itemUrl && sectionButton && sectionButton.setAttribute('href', itemUrl);
  }
  initAccordions();
  function initAccordions() {
    document.querySelectorAll('.accordions__wrapper .accordion__heading').forEach((trigger) => {
      trigger.addEventListener('click', () => toggleAccordion(trigger));
    });
    function toggleAccordion(trigger) {
      const content = trigger.closest('.accordion').querySelector('.accordion__content'),
        expanded = trigger.getAttribute('aria-expanded') === 'true';
      (trigger.setAttribute('aria-expanded', !expanded),
        content.classList.toggle('expanded', !expanded),
        (trigger.querySelector('.accordion__icon').innerHTML = getAccordionIcon(expanded)));
    }
    function getAccordionIcon(expanded) {
      return expanded
        ? '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M3.75 12H20.25" stroke="#0F0F0F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 3.75V20.25" stroke="#0F0F0F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        : '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M3.75 12H20.25" stroke="#0F0F0F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }
  }
  function removeActive(elements) {
    elements.forEach((element) => element.classList.remove('active'));
  }
});
//# sourceMappingURL=/s/files/1/0636/0265/5480/t/58/assets/section-sectionals.js.map?v=1724164931
